import { PACKAGES, waLink } from "../../data";
import { Reveal } from "./Reveal";
import { Sparkles, ArrowUpRight } from "lucide-react";

export const MixPackages = () => (
  <section id="paket" className="relative py-24 sm:py-32 bg-[#2c1e16] text-[#faf7f2] overflow-hidden grain">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 relative">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#b8862f] mb-4">
          Mix Paket Treatment
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl leading-tight">
          Racikan treatment favorit, dipadu jadi satu ritual utuh.
        </h2>
        <p className="mt-5 max-w-xl text-[#e5d9c5] leading-relaxed">
          Ingin lebih dari satu treatment sekaligus? Pilih paket kombinasi kami
          untuk pengalaman spa Jawa yang lebih lengkap.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-6 sm:grid-cols-2">
        {PACKAGES.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.08}>
            <div
              data-testid={`package-${i}`}
              className="group h-full rounded-3xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] p-8 transition-colors flex flex-col"
            >
              <Sparkles className="h-6 w-6 text-[#b8862f]" strokeWidth={1.5} />
              <h3 className="font-display text-3xl mt-5 leading-tight">
                {p.name}
              </h3>
              <p className="mt-3 text-[#b8862f] text-sm uppercase tracking-[0.12em]">
                {p.items}
              </p>
              <p className="mt-4 text-[#e5d9c5] leading-relaxed flex-1">
                {p.desc}
              </p>
              <a
                href={waLink(
                  `Halo Javanese Spa Jogja, saya tertarik dengan ${p.name} (${p.items}). Boleh info harga & booking?`
                )}
                target="_blank"
                rel="noreferrer"
                data-testid={`package-book-${i}`}
                className="mt-8 inline-flex items-center gap-2 text-sm text-[#faf7f2] link-underline w-fit"
              >
                Tanya & Booking Paket Ini
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
